import { css, cx } from '@emotion/css';
import { theme } from 'antd';
import type React from 'react';
import type { TestTubeColorProperties } from '../utils/enumHelpers.ts';

const { useToken } = theme;

export const TestTubeColor: React.FC<{
  properties: TestTubeColorProperties;
  withText?: boolean;
}> = ({ properties, withText = true }) => {
  const { token } = useToken();

  // Empty colorCode = "Keine Farbe" / "Unbekannte Farbe": no fill to show.
  const isEmpty = !properties.colorCode;
  const isWhite = properties.colorCode.toLowerCase() === '#efefef';

  // Only Weiß and the empty swatch sit too close to the background to read;
  // the vivid colors stand on their own and get no ring.
  const needsBorder = isEmpty || isWhite;

  const dotStyle = css`
    flex: none;
    box-sizing: border-box;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    ${needsBorder ? `border: 1px solid ${token.colorBorder};` : ''}
    background-color: ${isEmpty ? token.colorBgContainer : properties.colorCode};
  `;

  // Diagonal slash signals "no color" without a label.
  const slashStyle = css`
    background-image: linear-gradient(
      to top right,
      transparent calc(50% - 0.75px),
      ${token.colorTextTertiary} calc(50% - 0.75px),
      ${token.colorTextTertiary} calc(50% + 0.75px),
      transparent calc(50% + 0.75px)
    );
  `;

  // inline-flex so the swatch can flow within a line of text and wrap with it.
  const wrapperStyle = css`
    display: inline-flex;
    align-items: center;
    gap: ${token.marginXXS}px;
    white-space: nowrap;
    vertical-align: baseline;
  `;

  return (
    <span className={wrapperStyle}>
      <span className={cx(dotStyle, isEmpty && slashStyle)} title={withText ? undefined : properties.translation} />
      {withText ? properties.translation : ''}
    </span>
  );
};
